import { render } from "./EmployeeSalarySettings.vue?vue&type=template&id=faf6953a&scoped=true"
import script from "./EmployeeSalarySettings.vue?vue&type=script&lang=js"
export * from "./EmployeeSalarySettings.vue?vue&type=script&lang=js"

import "./EmployeeSalarySettings.vue?vue&type=style&index=0&id=faf6953a&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf6953a"]])

export default __exports__